<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7" />
        <path
            d="M9.2 9.3a2.8 2.8 0 0 1 5.6.4c0 1.9-2.8 2.3-2.8 4"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
        />
        <circle cx="12" cy="17" r="1.1" fill="currentColor" />
    </svg>
</template>